import { useGetFeatureQuery } from "../featuresSlice";

const useFeature = ({ id }) => {
  const feature = useGetFeatureQuery(
    { id },
    {
      skip: id == null,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    }
  );

  return feature;
};

export default useFeature;
